import {
  Box,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import * as React from "react";
import {
  Datagrid,
  List,
  TextField,
  useListContext,
  useRecordContext,
  useRefresh,
} from "react-admin"; // eslint-disable-line import/no-unresolved
import useNotify from "../unit/useNotify";

import { hmLightTheme } from "../themes/hmTheme";
import PostPagination from "../unit/PostPagination";

import DownloadIcon from "@mui/icons-material/Download";
import { RaRecord } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import CustomDateField from "../unit/CustomDateField";
import CustomLoading from "../unit/CustomLoading";
import ReportListNewAside from "./ReportListNewAside";
import HmLoading from "../unit/HmLoading";
import NoResults from "../unit/NoResults";
import { error } from "console";
import NoPermission from "../unit/NoPermission";
import { downloadCSV } from "react-admin";
import getFiltersFromURL from "../unit/getFiltersFromURL";
import { last } from "lodash";

const CustomStatusField = ({ ...props }) => {
  let record = useRecordContext();
  if (!record) return null;
  let status = record?.sStatus;
  if (record.sStatus == "1") {
    status = "Active";
  } else if (record.sStatus == "0") {
    status = "Inactive";
  }
  return <Typography>{status}</Typography>;
};

const ReportExporter = (records: any) => {
  const currentFilters = getFiltersFromURL();
  const filterStatus = currentFilters?.status;
  const filterReportType = currentFilters?.reportType;

  let data = [];
  let title = {};

  if (
    filterStatus == "Disbursements" ||
    filterStatus == "Repayments" ||
    filterStatus == "Inception to Date"
  ) {
    data = records.map((record: any) => {
      const { id } = record;
      return {
        id: id,
        division: record.division,
        title: record.title,
        coverBegins: record.coverBegins,
        coverEnds: record.coverEnds,
        created: record.created,
        download_count: record.download_count,
        lastdownload: record.lastdownload,
        lastBankerId: record.lastBankerId,
      };
    });
    title = {
      id: "Report ID",
      division: "Division",
      title: "Report Name",
      coverBegins: "Period Begins",
      coverEnds: "Period Ends",
      created: "Created On",
      download_count: "Times Downloaded",
      lastdownload: "Last Downloaded",
      lastBankerId: "Downloaded By",
    };
  } else if (
    filterStatus == "Loan Portfolio" ||
    filterStatus == "Metro II" ||
    filterStatus == "monthly_underwriting"
  ) {
    data = records.map((record: any) => {
      const { id } = record;
      return {
        id: id,
        division: record.division,
        title: record.title,
        asOfDate: record.asOfDate,
        created: record.created,
        download_count: record.download_count,
        lastdownload: record.lastdownload,
        lastBankerId: record.lastBankerId,
      };
    });
    title = {
      id: "Report ID",
      division: "Division",
      title: "Report Name",
      asOfDate: "As of Date",
      created: "Created On",
      download_count: "Times Downloaded",
      lastdownload: "Last Downloaded",
      lastBankerId: "Downloaded By",
    };
  } else {
    data = records.map((record: any) => {
      const { id } = record;
      return {
        id: id,
        division: record.division,
        title: record.title,
        created: record.created,
        download_count: record.download_count,
        lastdownload: record.lastdownload,
        lastBankerId: record.lastBankerId,
      };
    });
    title = {
      id: "Report ID",
      division: "Division",
      title: "Report Name",
      created: "Created On",
      download_count: "Times Downloaded",
      lastdownload: "Last Downloaded",
      lastBankerId: "Downloaded By",
    };
  }
  return {
    title: title,
    data: data,
  };
};
const CustomReportExporter = (records: any) => {
  const filterData = ReportExporter(records);
  const currentFilters = getFiltersFromURL();
  const filterStatus = currentFilters?.status;
  const filterReportType = currentFilters?.reportType;
  let download_file_name = "";
  if (
    filterStatus == "Inception to Date" &&
    filterReportType == "applications"
  ) {
    download_file_name = "Historic Reports_Applications_";
  } else if (
    filterStatus == "Inception to Date" &&
    filterReportType == "loans"
  ) {
    download_file_name = "Historic Reports_Loans_";
  } else if (
    filterStatus == "Inception to Date" &&
    filterReportType == "customers"
  ) {
    download_file_name = "Historic Reports_Customers_";
  } else if (
    filterStatus == "Inception to Date" &&
    filterReportType == "achpayments"
  ) {
    download_file_name = "Historic Reports_ACH Payments_";
  } else if (filterStatus == "Loan Portfolio") {
    download_file_name = "Month End Loan Portfolio_";
  } else if (filterStatus == "Disbursements") {
    download_file_name = "Monthly Disbursements_";
  } else if (filterStatus == "Repayments") {
    download_file_name = "Monthly Repayments_";
  } else if (filterStatus == "monthly_underwriting") {
    download_file_name = "Monthly_";
  } else if (filterStatus == "weekly_applications") {
    download_file_name = "Weekly_";
  } else if (filterStatus == "Metro II") {
    download_file_name = "Metro II_";
  }

  // console.log("filter_status=============================>>>>:", filter_status);
  let csvTitle = filterData.title;
  let data = filterData.data;
  const csvData = [{ ...csvTitle }, ...data];
  const csvDataStr = csvData.map((row) => Object.values(row).join(","));
  downloadCSV(csvDataStr.join("\n"), download_file_name + "Report");
};
const ReportList = () => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const refresh = useRefresh();
  const [selectedRecord, setSelectedRecord] = React.useState<RaRecord | null>(
    null
  );
  const [open, setOpen] = React.useState(false);
  const [currentTab, setCurrentTab] = React.useState("info");
  const [record, setRecord] = React.useState<{ total: number } | null>(null);
  const permissions =
    localStorage.getItem("bbaccess")?.toString().split(",") || [];
  if (!permissions.includes("personal_reports")) {
    return <NoPermission />;
  }
  const total = record ? record.total : 0;
  // const refresh = useRefresh();

  const handleRowClick = (
    id: any,
    resource: string,
    record: RaRecord,
    event: React.MouseEvent,
    basePath: string
  ) => {
    setSelectedRecord(record);
    event.stopPropagation();
  };
  const handleCancel = () => {
    setSelectedRecord(null);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedRecord(null);
    if (currentTab == "linkProducts") {
      // refresh();
    }
  };

  const CustomButton = ({}) => {
    const [loading, setLoading] = React.useState(false);
    const record = useRecordContext();
    const downloadpath = record?.downloadpath;
    const handDownload = async (docFileName: string, reqUrl: string) => {
      setLoading(true);
      try {
        const access_token = localStorage.getItem("access_token");
        const csrfToken = localStorage.getItem("csrfToken");
        const response = await fetch(
          import.meta.env.VITE_API_URL + `/${reqUrl}`,
          {
            headers: {
              Authorization: `Bearer ${access_token}`,
              "X-CSRF-TOKEN": csrfToken ?? "",
              "X-XSRF-TOKEN": csrfToken ?? "",
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();
        console.log("report response:", data?.download_url);
        if (data?.download_url) {
          const a = document.createElement("a");
          a.href = data?.download_url;
          a.download = data?.filename || docFileName;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();

          setTimeout(() => {
            document.body.removeChild(a);
          }, 100);
        } else {
          errorNotify("File not found");
        }
      } catch (error) {
        console.error("Error downloading attachment:", error);
      }
      setLoading(false);
    };

    return (
      <>
        <Tooltip title={`Download`} placement="left">
          <IconButton
            // onClick={() => handleDownloadReport(record?.title, downloadpath)}
            onClick={() => handDownload(record?.title, downloadpath)}
            // onClick={() => downloadExcelFile(record?.title, downloadpath)}
            disabled={loading}
            size="small"
            sx={{ ml: 1 }}
          >
            {loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <DownloadIcon fontSize="small" sx={{ color: "#1976d2" }} />
            )}
          </IconButton>
        </Tooltip>
        {/* <CustomEditRemoveIcon
          // onClick={() => handleRemove()}
          disabled
          color="gray"
          label="Remove"
        /> */}
      </>
    );
  };

  const handleButtonClick = (record: any) => {
    setOpen(true);
    setSelectedRecord(record);
  };

  const ReportGridTable = () => {
    const listContext = useListContext();
    const { total, data, isPending, isLoading, isFetching, error } =
      useListContext();

    // console.log("listContext error====>", error);
    if (isPending)
      return (
        <Typography sx={{ p: 5 }} className="hm-list-datagrid">
          pending...
        </Typography>
      );
    if (isFetching)
      return (
        <Typography sx={{ p: 5 }} className="hm-list-datagrid">
          loading ...
        </Typography>
      );
    if (!total || total === 0 || !data || data.length === 0) {
      return (
        <Typography sx={{ p: 5 }} className="hm-list-datagrid no-results">
          No reports found
        </Typography>
      );
    }
    const { filterValues } = listContext;
    const filterStatus = filterValues?.status;
    const authrole = localStorage.getItem("authrole");
    return (
      <Datagrid
        optimized
        rowClick={false}
        size="small"
        empty={false}
        id="table-reports"
        className="hm-list-datagrid"
        sx={{
          ".MuiTableCell-root": {
            padding: "6px",
          },
          ".RaDatagrid-headerCell:first-child": {
            borderTopLeftRadius: "0px",
          },
          ".RaDatagrid-headerCell:last-child": {
            borderTopRightRadius: "0px",
          },
          overflowY: "auto",
          "& .column-groups": {
            md: { display: "none" },
            lg: { display: "table-cell" },
          },
          "& .Mui-active": {
            color: "gray",
          },
          "& .MuiTableSortLabel-root": {
            padding: "5px",
          },
          "& .RaDatagrid-headerCell": {
            color: "gray",
            fontSize: "1rem",
            backgroundColor: "#edf4fb",
            wordWrap: "break-word",
          },
          "& .MuiTableCell-paddingCheckbox": {
            display: "none",
          },
          "& .MuiTableCell-root.column-title": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextLgWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextLgWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextLgWidth,
            textAlign: "left",
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          // lastdownload, width mdWidth
          "& .MuiTableCell-root.column-download_count": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            textAlign: "left",
          },
          "& .MuiTableCell-root.column-lastdownload": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            textAlign: "left",
          },
          "& .MuiTableCell-root.column-lastBankerId": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            textAlign: "left",
          },
          "& .MuiTableCell-root.column-column-action": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            textAlign: "left",
          },
        }}
      >
        {/* Report ID#	Description	Covered Period (for flow reports) As of Date (for snapshots)	Created On	Times Downloaded	Last Downloaded	Downloaded By	Action */}

        <TextField
          source="id"
          label="Report #"
          cellClassName="numericText"
          sortBy="id"
          sortable={false}
          className="report-id"
        />
        {authrole == "admin" && (
          <TextField source="bank" label="Institution Name" />
        )}

        {/* <TextField source="division" label="Division" sortBy="division" /> */}
        <TextField
          source="title"
          label="Report name"
          sortBy="title"
          sortable={true}
        />
        {/* <TextField source="month" label="Remove Month" sortBy="sTitle" />
        <TextField source="year" label="Remove Year" sortBy="sYear" /> */}
        {(filterStatus == "Disbursements" ||
          filterStatus == "Repayments" ||
          filterStatus == "Inception to Date") && (
          <TextField
            source="coverBegins"
            label="Period Begins"
            sortable={true}
            sortBy="coverBegins"
          />
        )}
        {(filterStatus == "Disbursements" ||
          filterStatus == "Repayments" ||
          filterStatus == "Inception to Date") && (
          <TextField
            source="coverEnds"
            label="Period Ends"
            sortable={true}
            sortBy="coverEnds"
          />
        )}
        {(filterStatus == "Loan Portfolio" ||
          filterStatus == "Metro II" ||
          filterStatus == "monthly_underwriting") && (
          <TextField
            source="asOfDate"
            label="As of Date"
            sortable={false}
            sortBy="asOfDate"
          />
        )}
        <CustomDateField
          source="created"
          label="Created On"
          sortBy="created"
          onlyShowDate={true}
          cellClassName="dateText"
          sortable={true}
        />
        {/* <CustomDateField
            source="completed"
            label="Covered Period"
            sortBy="dFileCompleted"
            onlyShowDate={true}
            cellClassName="dateText"
          /> */}
        <TextField
          source="download_count"
          label="Times Downloaded"
          sortBy="download_count"
          sortable={false}
        />
        <CustomDateField
          source="lastdownload"
          label="Last Downloaded"
          sortable={false}
          sortBy="lastdownload"
          onlyShowDate={true}
          cellClassName="dateText"
        />
        {/* <TextField
            source="lastBankerName"
            label="Downloaded By"
            sortable={false}
          /> */}
        <TextField
          source="lastBankerId"
          label="Downloaded By"
          sortable={false}
          sortBy="lastBankerId"
        />
        <CustomButton
          source="column-action"
          onClick={handleButtonClick}
          label="Action"
          sortable={false}
        />
      </Datagrid>
    );
  };
  return (
    <>
      <List
        // actions={
        //   <PartnersListActions
        //     selected="counselors"
        //     productList={productList}
        //     counselorList={counselorList}
        //   />
        // }

        exporter={CustomReportExporter}
        filters={[]}
        aside={<ReportListNewAside totalData={total} selected="" />}
        empty={
          <Typography className="no-results">
            <NoResults />
          </Typography>
        }
        emptyWhileLoading={false}
        loading={<HmLoading />}
        sort={{ field: "id", order: "DESC" }}
        sx={{
          width: "100%",
          borderRadius: "0px",
          wordBreak: "break-word",
          overflowX: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
          "& .add-filter": {
            display: "none",
          },
          "& .MuiCard-root": {
            borderRadius: "0px",
          },
          "& .RaList-actions form .filter-field .MuiInputBase-input": {
            width: "230px",
          },
          "& .RaList-actions .RaFilterForm-filterFormInput:first-child .MuiInputBase-root::before":
            {
              display: "none",
            },
          "& .RaList-actions .filter-field:first-child .MuiFormControl-root": {
            marginLeft: 0,
          },
        }}
        pagination={<PostPagination />}
        perPage={25}
      >
        <ReportGridTable />
        {/* <CustomLoading /> */}
      </List>
    </>
  );
};

export default ReportList;
